<section class="rcx-table">
    <div class="row">
        <div class="col-lg-12">
            <div class="card btr">
                <div class="card-content" [formGroup]="promotionForm" (ngSubmit)="savePromotion()">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-3">
                                <label for="Promotable" class="form-label">Promotable <b
                                        class="text-secondary">*</b></label>
                                <div class="d-flex align-items-center">
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="radio" id="yesOption" name="promotable"
                                            formControlName="promotable" [value]="true" [class.disabled]="isAssesmentCompleted " />
                                        <label class="form-check-label" for="yesOption">Yes</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="radio" id="noOption" name="promotable"
                                            formControlName="promotable" [class.disabled]="isAssesmentCompleted"
                                            [value]="false"/>
                                        <label class="form-check-label" for="noOption">No</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row g-3 mt-2">
                            <div class="col-md-12">
                                <label for="label" class="form-label">Comment</label>
                                <textarea type="text" class="form-control ps-1" id="label" placeholder="Enter Comment"
                                formControlName="reasonToPromote" autocomplete="off" [readonly]="isAssesmentCompleted"></textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>